import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoDe: CultureInfo = {
  name: 'de',
  displayName: 'German',
  iso3LanguageCode: 'deu',
  iso2LanguageCode: 'de',
  ietfLanguageTag: 'de',
  parent: null
};
